/**
 * Created by pzf on 18/9/1.
 *
 */
/* eslint func-names: 1 */
import React from 'react';
import PropTypes from 'prop-types';
import Trigger from 'rc-trigger';
import { Icon } from 'mkui-fd';
import { pick, isEqual } from 'lodash';
import Panel from '../fee-type-input/Panel';

import {
  getDataSource,
  getIconName,
} from './util';
import { BUILT_IN_PLACEMENTS, POPUP_PLACEMENT } from "./constant";



class Select extends React.Component {

  /** *******************static************************** */

  static getPopupContainer() {
    return document.body;
  }

  static propTypes = {
    prefixCls: PropTypes.string,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    data: PropTypes.array,
    value: PropTypes.object,
    lazyLoad: PropTypes.bool,
    api: PropTypes.func, // 异步加载时会用到
    placement: PropTypes.string,
  };

  static defaultProps = {
    prefixCls:'mkui-fee-type-input-icon',
    placeholder: '',
    onChange: null,
    disabled: false,
    data: [],
    lazyLoad: true,
    api: null,
    placement: POPUP_PLACEMENT,
  };

  static getDerivedStateFromProps(nextProps) {
    if ('value' in nextProps) {
      return {
        value: nextProps.value,
      };
    }
    return null;
  }

  /** *******************life cycle************************** */
  constructor(props) {
    super(props);
    this.state = this.getInitState(props);
    this.panelRef = React.createRef();
    this.observeParams = ['subsidiaryCode', 'formSubTypeCode'];
  }


  componentDidUpdate(prevProps) {
    const { params } = this.props;
    const prevParams = prevProps.params;
    if (!isEqual(pick(params, this.observeParams), pick(prevParams, this.observeParams))) {
      this.paramsDirty();
    }
  }

  /** *******************handle************************** */
  /**
   * 下拉箭头点击触发
   * @param e
   */
  iconClickHandle(e) {
    e.stopPropagation();
    e.preventDefault();
    const { disabled, open } = this.props;
    if (!disabled) {
      this.toggleDropdown(!open);
    }
  }

  /**
   * 下拉面板中选择选项后触发
   * @param items Array
   */
  selectHandle(items) {
    this.setState({ value: items[0], open: false });
    this.fireChange(items[0]);
  }


  onDropdownVisibleChangeHandle(open) {
    this.toggleDropdown(open);
  }

  /** *******************inner method************************** */

  getInitState(props) {
    const {value} = props;
    return {
      open: false,
      loaded: false,
      value,
      data: getDataSource(props),
    };
  }

  toggleDropdown(open) {
    const { loaded } = this.state;
    const { lazyLoad } = this.props;
    if (!lazyLoad) {
      this.setOpenState(open);
    } else {
      if (!loaded) {
        this.fetchData();
        this.setState({ open, loading: true });
      } else {
        this.setOpenState(open);
      }
    }
  }

  paramsDirty(){
    this.setState({ loaded: false, loading: true });
  }

  fetchData() {
    const { api, params } = this.props;
    api(params).then((data) => {
      this.setState({ data, loaded: true, loading: false });
    });
  }

  setOpenState(open) {
    this.setState({ open });
  }


  fireChange(value) {
    const { onChange } = this.props;
    onChange(value);
  }

  getPlaceholderElement() {
    const { placeholder, prefixCls } = this.props;
    if (placeholder) {
      return (
        <div
          className={`${prefixCls}-selection__placeholder`}
          unselectable="on"
        >
          {placeholder}
        </div>
      );
    }
    return null;
  }


  getDropdownElement() {
    const { prefixCls, value } = this.props;
    const { data, loading } = this.state;
    let selected;
    if (value) {
      selected = [value.code];
    } else {
      selected = [];
    }
    if (loading) {
      return <Icon type="loading" className={`${prefixCls}-loading`}/>;
    } else {
      return <Panel data={data} selected={selected} ref={this.panelRef} onSelect={(item) => {
        this.selectHandle(item);
      }}/>;
    }
  }

  /** *******************render method************************** */

  renderTopControlNode() {
    const { value } = this.state;
    const { disabled, prefixCls } = this.props;
    const className = `${prefixCls}-selection__rendered`;
    let innerNode = null;
    if (value) {
      const text = value.name;
      const selectedValue = (
        <div
          key="value"
          className={`${prefixCls}-selection-selected-value`}
          title={text}
        >
          {text}
        </div>
      );
      innerNode = [selectedValue];
    }
    return (
      <div className={className}>
        {!innerNode ? this.getPlaceholderElement() : innerNode}
      </div>
    );
  }


  renderDropdownIcon() {
    const { prefixCls } = this.props;
    return (
      <Icon
        type="down"
        className={`${prefixCls}-selection-icon`}
        onClick={event => this.iconClickHandle(event)}
      />
    );
  }

  renderIcon(){
    const { prefixCls } = this.props;
    const { value } = this.state;
    const icon = value && value.icon ? getIconName(value.icon) : 'question-circle';
    return <Icon className={`${prefixCls}-icon`} type={icon}/>
  }

  render() {
    const { disabled, prefixCls, placement } = this.props;
    const { open, value } = this.state;
    const ctrlNode = this.renderTopControlNode();
    const popupElement = this.getDropdownElement();

    const rootCls = {
      [prefixCls]: 1,
      [`${prefixCls}-open`]: open,
      [`${prefixCls}-disabled`]: disabled,
    };
    return (
      <Trigger
        showAction={disabled ? [] : ['click']}
        hideAction={['click']}
        popupPlacement={placement}
        builtinPlacements={BUILT_IN_PLACEMENTS}
        prefixCls="mkui-popedit-dropdown-wrapper"
        popup={popupElement}
        mask
        getPopupContainer={Select.getPopupContainer}
        onPopupVisibleChange={visible => this.onDropdownVisibleChangeHandle(visible)}
        popupVisible={open}
      >
        <div
          className={rootCls}
        > {this.renderIcon()}
          <div
            className={`${prefixCls}-selection`}
          >
            {ctrlNode}
            {this.renderDropdownIcon()}
          </div>
        </div>
      </Trigger>


    );
  }
}

export default Select;
